






import { Component, Vue } from 'vue-property-decorator'
import Home from './views/Home.vue'
import setShareContent from '@bilibili/fe-quick-share'
import { callNative } from './utils/common'
import { openSharePanel } from './utils/share'
import logger from '@plat-components/utils2/_esm5/logger'
// import VConsole from 'vconsole'
@Component({
  components: {
    Home,
  },
})
export default class App extends Vue {
  mounted() {
    // const vConsole = new VConsole()
    // console.log('vConsole', vConsole)
    this.setDefineBar()
  }

  // 设置返回和分享按钮
  setDefineBar() {
    const { origin, pathname } = location || {}
    const shareUrl = `${origin}${pathname}?msource=shareh5`
    const title = 'B站宣布五一免费开放其超大型纪录片片库'
    const description = '3442部全部免费！'
    const avatar =
      'https://activity.hdslb.com/blackboard/static/ba7b9ddd165e781074ed422118c29607/WHFHtEKQZi.png'
    const editContent = 'B站宣布五一免费开放其超大型纪录片片库'
    const shareId = 'jlpsy-list'
    const shareOrigin = 'share_url'
    setShareContent({
      business: 'OGV',
      shareScene: 'top-right-share',
      pageId: '2022-may-documentary',
      defineBar: true,
      shareUrls: [shareUrl],
      share2Config: {
        oid: shareUrl,
        sid: '',
      },
      shareInfo: {
        DEFAULT: {
          type: 'link',
          title: title,
          url: shareUrl,
          desc: description,
          avatar: avatar,
          imageUrl: avatar,
        },
      },
      bars: {
        leftBars: [
          {
            action: () => {
              callNative({
                method: 'global.closeBrowser',
              })
            },
            icon: require('./assets/images/icon-back.png'),
          },
        ],
        rightBars: [
          {
            action: () => {
              console.log('点击')
              logger('searchlist.share', {})
              openSharePanel({
                title: title,
                description: description,
                url: shareUrl,
                avatar: avatar,
                editContent: editContent,
                shareConfig: {
                  nodeList: [],
                  width: 100,
                  height: 100,
                },
                shareImageUrl: avatar,
                callback: () => {
                  console.log('callback')
                },
                share_id: shareId,
                share_origin: shareOrigin,
              })
            },
            icon: require('./assets/images/icon-share.png'),
          },
        ],
      },
    })
  }
}
